import { OrderedSet, List, fromJS } from 'immutable';
import { SEARCH } from '../../../constants/configTypes';
import { COUNT } from '../../../constants/metricTypes';
import * as DataTypes from '../../../constants/dataTypes';
import { DESC } from '../../../constants/sortOrder';
// @ts-expect-error Untyped import
import { Config } from '../..';
// @ts-expect-error Untyped import
import { Metric } from '../../metrics';
import { makeFilters } from '../filters';
import { buildDrilldownReport } from '../report';
import { DRILLDOWN_TYPES } from '../../../constants/trackingMetrics';
import { isConfigReport } from '../../../tsTypes/reportTypes';
import { getDataType } from '../../../report/reportGetters';
import { fetchDataSystemMetadata } from '../../../v2/externalDataSystemMetadata/fetchMetadata';
import { isExternalDataType } from '../../../report/externalReportGetters';
const getExternalDataTypeDrilldown = (report, keys, options) => {
  const config = report.get('config');
  const dimensions = config.get('dimensions') || List();
  const dataType = getDataType(report);
  const dateRangeProperty = config.getIn(['filters', 'dateRange', 'property']);
  const filterProperties = dateRangeProperty != null ? [dateRangeProperty] : [];
  const metric = keys.get(report.getIn(['config', 'dimensions'], List()).count());
  const metricProperties = (config.get('metrics') || List()).map(m => m.get('property')).filter(property => property !== 'count');
  const dataColumnProperties = report.getIn(['displayParams', 'dataColumns']) || [];
  return Promise.all([makeFilters(config, keys, Object.assign({}, options)), fetchDataSystemMetadata(dataType)]).then(([generatedFilters, dataSystemMetadata]) => {
    const drilldownConfig = dataSystemMetadata ? dataSystemMetadata.drilldownProperties.value : [];
    const drilldownConfigForMetric = drilldownConfig.find(ddConfig => ddConfig.metricName === metric) || {};
    const {
      metrics: drilldownMetrics = [],
      configType,
      dataType: drilldownDataType = DataTypes.EXTERNAL,
      externalDataTypeSource,
      objectTypeId,
      dimensions: drilldownDimensions = [],
      unifiedEvent,
      filters: drilldownFilters = []
    } = drilldownConfigForMetric;
    const isUEDataType = drilldownDataType === DataTypes.UNIFIED_EVENTS;
    const metrics = drilldownMetrics && drilldownMetrics.length > 0 ?
    // Use metadata defined drilldown metrics as is
    List([...drilldownMetrics]).map(property => Metric(property)) :
    // Build metrics from config defined dimensions, filters, and data columns
    OrderedSet([...dimensions.toJS(), ...filterProperties, ...metricProperties.toJS(), ...dataColumnProperties]).toList().map(property => Metric(Object.assign({
      property
    }, !isUEDataType ? {
      metricTypes: [COUNT]
    } : {})));

    // Apply the generated filters to the filters from the metadata
    if (drilldownFilters && drilldownFilters.length > 0) {
      const customFilters = drilldownFilters.reduce((acc, filter) => {
        const existingFilter = generatedFilters.get('custom', List()).find(f => f.get('property') === filter.property);
        if (existingFilter) {
          return acc.push(existingFilter);
        }
        return acc.push(filter);
      }, List());
      generatedFilters = generatedFilters.set('custom', customFilters);
    }
    return Config({
      configType: configType || SEARCH,
      limit: 5,
      dataType: drilldownDataType,
      externalDataTypeSource: externalDataTypeSource || dataType,
      objectTypeId,
      dimensions: drilldownDimensions,
      metrics,
      unifiedEvent,
      filters: generatedFilters,
      sort: !isUEDataType ? fromJS([{
        property: metric,
        order: DESC
      }]) : fromJS([])
    });
  }).then(drilledConfig => buildDrilldownReport(report, drilledConfig, options));
};
const inboundDbGenerator = {
  isSupported: report => {
    const dataType = isConfigReport(report) ? getDataType(report) : undefined;
    return !!isExternalDataType(dataType);
  },
  generate: getExternalDataTypeDrilldown,
  trackingName: DRILLDOWN_TYPES.EXTERNAL
};
export default inboundDbGenerator;